<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
            <div>
	  		      <span class="text-subtitle-1 d-block">Grupos</span>
              <span class="text-caption grey--text text--darken-1 d-block">
                Editando: {{ getdatosUsuarioERPERP.nombre_completo }}
              </span>
            </div>
	  		    <v-spacer></v-spacer>

	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( filterGrupos.filter( el => el.activo_sn == 1 )  , 'GRUPOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

	  		   <v-btn
              color="black"
              dark
              class="mr-2"
              @click="dialogGruposSiguientes = true"
              small
              tile
              v-if="accessGruposSiguientes"
            >
              <v-icon small left>mdi-page-next</v-icon>
              Grupo Siguiente
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true, agregarGrupo = true"
              small
              tile
              v-if="accessAgregarGrupo"
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              v-if="accessAccionMasiva && selectedPuedeDesactivar"
              color="red darken-2"
              dark
              class="mr-2 text-capitalize"
              :disabled="cargar"
              :loading="cargarAccionMasiva === 'desactivar'"
              @click="actualizarEstatusMasivo(0)"
              small
              tile
            >
              <v-icon left small>mdi-close-circle</v-icon>
              Desactivar ({{ seleccionActivosCount }})
            </v-btn>

            <v-btn
              v-if="accessAccionMasiva && selectedPuedeActivar"
              color="green darken-2"
              dark
              class="mr-2 text-capitalize"
              :disabled="cargar"
              :loading="cargarAccionMasiva === 'activar'"
              @click="actualizarEstatusMasivo(1)"
              small
              tile
            >
              <v-icon left small>mdi-check-circle</v-icon>
              Activar ({{ seleccionInactivosCount }})
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>  		    
	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row>
	  		  		<!-- Seleccionar el plantel -->
							<v-col cols="12" md="4" lg="2">
	  		  			<v-autocomplete
	  		  			  label="Plantel"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  v-model="plantel"
	  		  			  :items="planteles"
	  		  			  item-text="plantel"
	  		  			  item-value="id_plantel"
	  		  			  clearable
                  single-line
	  		  			></v-autocomplete>
	  		  		</v-col> 	

	  		  		<!-- Seleccionar el ciclo -->
	  		  		<v-col cols="12" md="4" lg="2">
	  		  			<v-autocomplete
	  		  			  label="Ciclo"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  v-model="ciclo"
	  		  			  :items="ciclos"
	  		  			  item-text="ciclo"
	  		  			  item-value="id_ciclo"
	  		  			  clearable
                  single-line
	  		  			></v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" md="4" lg="2">
				        <v-autocomplete
				        	:items="niveles"
				          v-model="nivel"
				          label="Nivel"
				          hide-details
                  single-line
				          dense
				          filled
				          item-text="nivel"
				          clearable
				          item-value="id_nivel"
				        ></v-autocomplete>
				      </v-col>

	  		  		<v-col cols="12" md="4" lg="2">
                <v-select
                  :items="opcionesActivos"
                  v-model="activos"
                  label="Activos"
                  item-text="text"
                  item-value="value"
                  filled
                  dense
                  single-line
                  hide-details
                >
                  <template v-slot:selection="{ item }">
                    <span class="d-flex align-center">
                      <v-icon v-if="item.value === 'Calavera'" small left>mdi-skull</v-icon>
                      {{ item.text }}
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span class="d-flex align-center">
                      <v-icon v-if="item.value === 'Calavera'" small left>mdi-skull</v-icon>
                      {{ item.text }}
                    </span>
                  </template>
                </v-select>
              </v-col>

	  		  		<v-col cols="12" md="4" lg="2">
                <v-select
                  :items="opcionesCantidadAlumnos"
                  v-model="filtroCantidadAlumnos"
                  label="Alumnos"
                  filled
                  dense
                  single-line
                  hide-details
                  clearable
                ></v-select>
              </v-col>

	  		  		<v-col cols="12" md="4" lg="4">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
                  single-line
	  		  			  clearable
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
                  v-model="selectedGruposAccion"
							    :headers="headers"
							    :items="filterGrupos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
			            id="grupos"
                  :show-select="accessAccionMasiva"
                  item-key="id_grupo"
							  >
                  <template v-if="accessAccionMasiva" v-slot:item.data-table-select="{ item, isSelected, select }">
                    <v-simple-checkbox
                      v-if="grupoPermiteCambioActivo(item)"
                      class="v-data-table__checkbox"
                      :value="isSelected"
                      :disabled="cargar"
                      color="primary"
                      @input="select"
                    />
                  </template>
                  <template v-if="accessAccionMasiva" v-slot:header.data-table-select>
                    <span></span>
                  </template>

							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>

							    <template v-slot:item.reubicacion="{ item }">
							    	<div class="d-flex justify-center align-center py-1">
							    		<v-tooltip v-if="grupoConCalavera(item)" bottom color="blue" max-width="280">
							    			<template v-slot:activator="{ on, attrs }">
							    				<span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
							    					<v-icon color="grey darken-2" small>mdi-skull</v-icon>
							    				</span>
							    			</template>
							    			<span>Grupo por reubicar (calavera)</span>
							    		</v-tooltip>
							    		<span v-else class="grey--text text--lighten-1">—</span>
							    	</div>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item), agregarGrupo = false "
							    		class="mr-2 mb-1"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="blue" 
							    		x-small
							    		dark
							    		@click="grupoZoom = item, dialogZoom = true"
							    		class="mr-2 mb-1"
							    	>
								      <v-icon small>mdi-file-video</v-icon>
							    	</v-btn>

							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="1200px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_grupo }}</strong>
          </span>
        </v-card-title>
        <v-tabs vertical v-model="tabs">
        	<!-- Grupo -->
		      <v-tab class="text-capitalize" >
		        <v-icon left>
		          mdi-home
		        </v-icon>
		        Grupo
		      </v-tab>
		      <!-- Descuento -->
		      <v-tab class="text-capitalize" v-if="editedIndex != -1">
		        <v-icon left>
		          mdi-percent-outline
		        </v-icon>
		        Descuento
		      </v-tab>
		      <!-- Maestros -->
		      <v-tab class="text-capitalize" v-if="editedIndex != -1">
		        <v-icon left>
		          mdi-school-outline
		        </v-icon>
		        Maestros
		      </v-tab>
		      <!-- Maestros -->
		      <v-tab class="text-capitalize" v-if="editedIndex != -1">
		        <v-icon left>
		          mdi-account
		        </v-icon>
		        Alumnos
		      </v-tab>

		      <!-- Siguiente grupo -->
		      <v-tab class="text-capitalize" v-if="editedIndex != -1">
		        <v-icon left>
		          mdi-skip-next
		        </v-icon>
		        Siguiente
		      </v-tab>

		      <!-- información del grupo -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		          	<InfoGrupo
                v-if="tabs == 0"
                :editedItem="editedItem"
                :gruposOcupacion="grupos"
                :horariosCatalog="horariosCatalog"
                @click="initialize()"
              /> 
			        </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <!-- Descuentos -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <DescuentoGrupo  v-if="tabs == 1" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <MaestrosGrupo v-if="tabs == 2" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <AlumnosGrupo  v-if="tabs == 3" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <v-tab-item>
		        <v-card flat>
		          <v-card-text class="pt-0">
		            <SiguienteGrupo
                v-if="tabs == 4"
                :editedItem="editedItem"
                :gruposOcupacion="grupos"
                :horariosCatalog="horariosCatalog"
                @click="initialize()"
              />
		          </v-card-text>
		        </v-card>
		      </v-tab-item>
		    </v-tabs>

        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogGruposSiguientes"
      persistent
      max-width="1200"
    >
      <v-card style="position: relative;">
        <v-overlay :value="cargar" absolute opacity="0.55" z-index="4">
          <v-card
            width="300"
            color="primary"
            dark
            class="elevation-8"
          >
            <v-card-text class="text-subtitle-1">
              Procesando apertura…
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0 mt-2"
              />
            </v-card-text>
          </v-card>
        </v-overlay>

        <v-card-title class="text-h6 mb-4">
          Apertura de grupos siguientes
          <v-spacer></v-spacer>
          <v-btn 
          	color="green"
          	dark
          	small
          	rounded
          	class="mr-2"
            :disabled="cargar"
            :loading="cargar"
          	@click="getGruposSiguientes"
          >
        		Actualizar
        	</v-btn>
          <v-btn 
          	color="primary" 
          	small 
          	rounded 
          	:disabled="cargar || !selectedGruposSiguientes.length"
            :loading="cargar"
          	@click="procesarGruposSeleccionados"
            class="mr-6"
          >
        		Procesar seleccionados ({{ selectedGruposSiguientes.length }})
        	</v-btn>
        </v-card-title>


        <v-card-text>
        	<v-row align="end">
  		  		<v-col cols="12" md="4" lg="3">
  		  			<v-autocomplete
  		  			  label="Ciclo"
  		  			  id="id"
  		  			  dense
                filled
                rounded
                single-line
  		  			  v-model="cicloSiguiente"
  		  			  :items="ciclosSiguientes"
  		  			  item-text="ciclo"
  		  			  item-value="id_ciclo"
  		  			  clearable
  		  			  return-object
                hide-details
                :disabled="cargar"
  		  			></v-autocomplete>
  		  		</v-col>
            <v-col cols="12" md="4" lg="3">
              <v-select
                v-model="escuelaSiguiente"
                :items="opcionesEscuelaSiguiente"
                label="Escuela"
                dense
                filled
                rounded
                single-line
                hide-details
                :disabled="cargar"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <v-select
                v-model="estatusFiltroSiguiente"
                :items="opcionesEstatusSiguiente"
                label="Estatus"
                dense
                filled
                rounded
                single-line
                hide-details
                :disabled="cargar"
              ></v-select>
            </v-col>
  		  		<v-col cols="12" md="6" lg="3">
  		  			<v-text-field
  		  			  name="name"
  		  			  label="Buscar"
  		  			  id="id"
                filled
                rounded
                single-line
  		  			  dense
  		  			  append-icon="mdi-magnify"
  		  			  v-model="searchSiguiente"
  		  			  clearable
  		  			  hide-details
                :disabled="cargar"
  		  			></v-text-field>
  		  		</v-col>
  		  	</v-row>
  		  	<v-row class="mt-2">
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded color="grey lighten-4" class="pa-3 text-center">
                <div class="text-caption grey--text text--darken-1">Grupos</div>
                <div class="text-h6">{{ kpiSiguientes.total }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded color="green lighten-5" class="pa-3 text-center">
                <div class="text-caption green--text text--darken-2">Alta</div>
                <div class="text-h6 green--text text--darken-2">{{ kpiSiguientes.conAlta }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded color="red lighten-5" class="pa-3 text-center">
                <div class="text-caption red--text text--darken-2">No alta</div>
                <div class="text-h6 red--text text--darken-2">{{ kpiSiguientes.sinAlta }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded color="blue lighten-5" class="pa-3 text-center">
                <div class="text-caption blue--text text--darken-2">Alumnos</div>
                <div class="text-h6 blue--text text--darken-2">{{ kpiSiguientes.totalAlumnos }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded color="purple lighten-5" class="pa-3 text-center">
                <div class="text-caption purple--text text--darken-2">Seleccionados</div>
                <div class="text-h6 purple--text text--darken-2">{{ selectedGruposSiguientes.length }}</div>
              </v-sheet>
            </v-col>
  		  	</v-row>
          <v-data-table
            v-model="selectedGruposSiguientes"
            :headers="headersGruposSiguientes"
            :items="gruposSiguientesFiltrados"
            class="elevation-0 mt-4"
            dense
            :search="searchSiguiente"
            show-select
            item-key="id_grupo"
            selectable-key="isSelectable"
          >
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox
                v-if="!item.estatus"
                class="v-data-table__checkbox"
                :value="isSelected"
                :disabled="cargar"
                color="primary"
                @input="select"
              />
            </template>
          	<template v-slot:item.estatus="{ item }">
				      <v-chip 
								small
				      	:color="item.estatus ? 'green' : 'red' "
				      	dark
				      >
				      	{{ item.estatus ? 'Alta' : 'NO ALTA' }}
				      </v-chip>
				    </template>
						<!-- v-if="item.estatus == 0 && item.cant_alumnos > 0" -->
				    <template v-slot:item.actions="{ item }">
				      <v-chip 
								small
				      	color="primary"
				      	dark
                :disabled="cargar"
				      	@click="procesarUnGrupo( item )"
                v-if="item.estatus == 0 "
				      >
				      	Agregar
				      </v-chip>
				    </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
                small
              >
                Actualizar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            class=""
            rounded
            dark
            small
            icon
            absolute
            top
            right
            :disabled="cargar"
            @click="dialogGruposSiguientes = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogZoom"
      persistent
      max-width="400"
      v-if="grupoZoom"
    >
      <v-card>
        <v-card-title class="text-h5">
          Agregar codigos al grupo
        </v-card-title>
        <v-card-text>
	  			<v-textarea
	  				v-model="grupoZoom.codigos"
	  				rows="3"
	  				auto-grow
	  				label="Agregar acceso al zoom"
	  				filled
	  				hide-details
	  			/>
        </v-card-text>
        <v-card-actions>
        	<v-btn
            color="black"
            tile
            dark
            small
            @click="dialogZoom = false"
          >
          	<v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="saveCodigoZoom()"
            absolute
            top
            right
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Dialog de carga / avisos (Alerta siempre montada para que el popup abra bien) -->
    <Alerta :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';
  import AlumnosGrupo    from '@/components/grupos/AlumnosGrupo.vue';
  import MaestrosGrupo   from '@/components/grupos/MaestrosGrupo.vue';
  import DescuentoGrupo  from '@/components/grupos/DescuentosGrupo.vue';
  import InfoGrupo       from '@/components/grupos/InfoGrupo.vue';
  import SiguienteGrupo  from '@/components/grupos/SiguienteGrupo.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
      AlumnosGrupo,
      MaestrosGrupo,
      DescuentoGrupo,
      InfoGrupo,
      SiguienteGrupo
    },

    data: () => ({
    	tabs: 0, 
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      grupoZoom: null,
			dialogZoom: false,

      editedItem: {
        id_grupo:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      defaultItem: {
        id_grupo:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      // Filtros: 
      incio:null,
			fin:null,
			plantel: null,
			ciclo: null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      grupos: [],
      headers: [
        { text: 'ID'        , value: 'id_grupo'    },
        { text: 'Grupo'     , value: 'grupo'       },
        { text: 'Plantel'   , value: 'plantel'     },
        { text: 'Curso'     , value: 'curso'       },
        { text: 'Ciclo'     , value: 'ciclo'       },
        { text: 'Horario'   , value: 'horario'     },
        { text: 'Salón'     , value: 'salon'       },
        { text: 'Nivel'     , value: 'nivel'       },
        { text: 'Precio'    , value: 'precio'      },
        { text: 'Cupo'      , value: 'cupo'        },
        { text: 'Alumnos'   , value: 'alumnos'     },
        { text: 'Activo'    , value: 'activo_sn'   },
        { text: 'Reubicación', value: 'reubicacion', align: 'center' },
        { text: 'Alta'      , value: 'fecha_alta'  },
        { text: 'Baja'      , value: 'fecha_baja'  },
        { text: 'Actions'   , value: 'actions', sortable: false },
      ],

      
      headersGruposSiguientes: [
        { text: 'ID'        , value: 'id_grupo'     },
        { text: '#alumnos'  , value: 'cant_alumnos' },
        { text: 'Grupo'     , value: 'grupo_viejo'  },
        { text: 'Siguiente' , value: 'grupo'        },
        { text: 'Activo'    , value: 'activo_sn'    },
        { text: 'Estatus'   , value: 'estatus'      },
        { text: 'Actions'   , value: 'actions', sortable: false },
      ],

      gruposSiguientes:[],
      searchSiguiente:'',
      escuelaSiguiente: 'TODOS',
      opcionesEscuelaSiguiente: ['TODOS', 'FAST', 'INBI'],
      estatusFiltroSiguiente: 'TODOS',
      opcionesEstatusSiguiente: ['TODOS', 'ALTA', 'NO ALTA'],
      selectedGruposSiguientes: [],
      selectedGruposAccion: [],
      cargarAccionMasiva: '',
      nivelesExcluidosSiguientes: [0],

      ciclos:[],
			salones:[],
			cursos:[],
			planteles:[],
			horarios:[],
			horariosCatalog:[],
			niveles:[],
			dialogGruposSiguientes: false,
			cicloSiguiente: null,
			ciclosSiguientes:[],
			activos: 'Todos',
			opcionesActivos: [
				{ text: 'Activos', value: 'Activos' },
				{ text: 'Inactivos', value: 'Inactivos' },
				{ text: 'Todos', value: 'Todos' },
				{ text: 'Calavera', value: 'Calavera' },
			],
			filtroCantidadAlumnos: null,
			agregarGrupo:false,

			nivel : null,

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Grupo' : 'Editar Grupo'
      },

      accessAgregarGrupo () {
        const u = this.getdatosUsuarioERPERP || {}
        const puesto = Number(u.idpuesto || u.id_puesto)
        return [1, 334, 568, 1312, 28].includes(u.iderp) || puesto === 11 || puesto === 12
      },

      /** Plantel / ciclo / nivel / activo-calavera (sin filtro de cantidad de alumnos). */
      gruposBaseFiltrados () {
      	let grupos = this.grupos || []

      	if (this.plantel) {
      		grupos = grupos.filter(el => el.id_plantel == this.plantel)
      	}
      	if (this.ciclo) {
      		grupos = grupos.filter(el => el.id_ciclo == this.ciclo)
      	}
      	if (this.nivel) {
      		grupos = grupos.filter(el => el.id_nivel == this.nivel)
      	}

      	if (this.activos === 'Activos') {
      		grupos = grupos.filter(el => el.activo_sn == 1)
      	} else if (this.activos === 'Inactivos') {
      		grupos = grupos.filter(el => el.activo_sn == 0)
      	} else if (this.activos === 'Calavera') {
      		grupos = grupos.filter(el => this.grupoConCalavera(el))
      	}

      	return grupos
      },

      /** Números de alumnos únicos de la lista actual, ordenados (0,1,2,3...). */
      opcionesCantidadAlumnos () {
      	const unicos = new Set()
      	for (const g of this.gruposBaseFiltrados) {
      		const n = Number(g.alumnos)
      		if (Number.isFinite(n) && n >= 0) unicos.add(n)
      	}
      	return Array.from(unicos).sort((a, b) => a - b)
      },

      /** Plantel / ciclo / nivel / activo-calavera (sin filtro de cantidad de alumnos). */
      gruposBaseFiltrados () {
      	let grupos = this.grupos || []

      	if (this.plantel) {
      		grupos = grupos.filter(el => el.id_plantel == this.plantel)
      	}
      	if (this.ciclo) {
      		grupos = grupos.filter(el => el.id_ciclo == this.ciclo)
      	}
      	if (this.nivel) {
      		grupos = grupos.filter(el => el.id_nivel == this.nivel)
      	}

      	if (this.activos === 'Activos') {
      		grupos = grupos.filter(el => el.activo_sn == 1)
      	} else if (this.activos === 'Inactivos') {
      		grupos = grupos.filter(el => el.activo_sn == 0)
      	} else if (this.activos === 'Calavera') {
      		grupos = grupos.filter(el => this.grupoConCalavera(el))
      	}

      	return grupos
      },

      /** Números de alumnos únicos de la lista actual, ordenados (0,1,2,3...). */
      opcionesCantidadAlumnos () {
      	const unicos = new Set()
      	for (const g of this.gruposBaseFiltrados) {
      		const n = Number(g.alumnos)
      		if (Number.isFinite(n) && n >= 0) unicos.add(n)
      	}
      	return Array.from(unicos).sort((a, b) => a - b)
      },

      filterGrupos( ){
      	let grupos = this.gruposBaseFiltrados

      	if (this.filtroCantidadAlumnos !== null && this.filtroCantidadAlumnos !== undefined && this.filtroCantidadAlumnos !== '') {
      		const cant = Number(this.filtroCantidadAlumnos)
      		grupos = grupos.filter(el => Number(el.alumnos) === cant)
      	}

      	return grupos
      },

      gruposSiguientesFiltrados () {
        let list = (this.gruposSiguientes || []).filter((el) => {
          const id = Number(el.id_nivel)
          return !this.nivelesExcluidosSiguientes.includes(id)
        })

        if (this.escuelaSiguiente === 'FAST') {
          list = list.filter((el) => this.grupoNombreTieneFast(el))
        } else if (this.escuelaSiguiente === 'INBI') {
          list = list.filter((el) => !this.grupoNombreTieneFast(el))
        }

        if (this.estatusFiltroSiguiente === 'ALTA') {
          list = list.filter((el) => el.estatus)
        } else if (this.estatusFiltroSiguiente === 'NO ALTA') {
          list = list.filter((el) => !el.estatus)
        }

        return list.map((item) => ({
          ...item,
          isSelectable: !item.estatus,
        }))
      },

      kpiSiguientes () {
        const rows = this.gruposSiguientesFiltrados || []
        const conAlta = rows.filter((el) => el.estatus).length
        const sinAlta = rows.filter((el) => !el.estatus).length
        const totalAlumnos = rows.reduce((acc, el) => acc + (Number(el.cant_alumnos) || 0), 0)
        return {
          total: rows.length,
          conAlta,
          sinAlta,
          totalAlumnos,
        }
      },
      accessGruposSiguientes () {
        const u = this.getdatosUsuarioERPERP || {}
        const puesto = Number(u.idpuesto || u.id_puesto)
        return [1, 334, 568, 1312, 28].includes(u.iderp) || puesto === 11 || puesto === 12
      },
      accessAccionMasiva () {
        return [1, 334, 568, 1312].includes(this.getdatosUsuarioERPERP.iderp)
      },
      seleccionActivosCount () {
        return (this.selectedGruposAccion || []).filter((g) => Number(g.activo_sn) === 1).length
      },
      seleccionInactivosCount () {
        return (this.selectedGruposAccion || []).filter((g) => Number(g.activo_sn) === 0).length
      },
      selectedPuedeActivar () {
        return this.seleccionInactivosCount > 0
      },
      selectedPuedeDesactivar () {
        return this.seleccionActivosCount > 0
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      tabs( val ) { console.log( val ) },

      opcionesCantidadAlumnos (opts) {
        if (this.filtroCantidadAlumnos === null || this.filtroCantidadAlumnos === undefined || this.filtroCantidadAlumnos === '') return
        if (!(opts || []).includes(Number(this.filtroCantidadAlumnos)) && !(opts || []).includes(this.filtroCantidadAlumnos)) {
          this.filtroCantidadAlumnos = null
        }
      },

      cicloSiguiente (val) {
        if (val) {
          this.selectedGruposSiguientes = []
          this.getGruposSiguientes()
        }
      },


      ciclo( ){
      	if( this.ciclo ){
      		this.initialize()
      	}
      },

      escuelaSiguiente () {
        this.pruneSeleccionGruposSiguientes()
      },

      estatusFiltroSiguiente () {
        this.pruneSeleccionGruposSiguientes()
      },
      plantel () {
        this.pruneSeleccionGruposAccion()
      },
      nivel () {
        this.pruneSeleccionGruposAccion()
      },
      activos () {
        this.pruneSeleccionGruposAccion()
      },

    },

    async created () {
      // await this.initialize()
      await this.getCiclos()
      await this.getPlanteles()
      await this.getCiclosDisponibles()
      await this.getNiveles( )
      await this.getHorariosCatalog()
    },

    methods: {
      grupoNombreTieneFast (item) {
        const s = `${item.grupo || ''} ${item.grupo_viejo || ''}`.toUpperCase()
        return s.includes('FAST')
      },

      /** En apertura, grupo_viejo con NIVEL 14/16 se ocultaba; TEENS NIVEL 14 sí debe listarse en columna Grupo. */
      incluirGrupoSiguienteEnLista (item) {
        const viejo = String(item.grupo_viejo || '').toUpperCase()
        if (viejo.includes('NIVEL 14')) {
          return viejo.includes('TEENS')
        }
        if (viejo.includes('NIVEL 16')) {
          return false
        }
        return true
      },

      pruneSeleccionGruposSiguientes () {
        const ids = new Set((this.gruposSiguientesFiltrados || []).map((g) => g.id_grupo))
        this.selectedGruposSiguientes = (this.selectedGruposSiguientes || []).filter((g) => ids.has(g.id_grupo))
      },
      grupoPermiteCambioActivo (item) {
        return Number(item && item.alumnos) === 0
      },
      pruneSeleccionGruposAccion () {
        const ids = new Set(
          (this.filterGrupos || [])
            .filter((g) => this.grupoPermiteCambioActivo(g))
            .map((g) => Number(g.id_grupo))
        )
        this.selectedGruposAccion = (this.selectedGruposAccion || []).filter((g) => ids.has(Number(g.id_grupo)))
      },
      async actualizarEstatusMasivo (activoSn) {
        if (this.cargar) return
        const objetivo = Number(activoSn) === 1 ? 1 : 0
        const seleccion = (this.selectedGruposAccion || [])
          .filter((g) => this.grupoPermiteCambioActivo(g))
          .filter((g) => Number(g.activo_sn) !== objetivo)

        if (!seleccion.length) {
          this.validarErrorDirecto('No hay grupos seleccionados para actualizar.')
          return
        }

        this.cargar = true
        this.cargarAccionMasiva = objetivo === 1 ? 'activar' : 'desactivar'
        try {
          for (const grupo of seleccion) {
            const payload = {
              ...grupo,
              activo_sn: objetivo,
              id_usuario: this.getdatosUsuarioERPERP.iderp
            }
            await this.$http.put(`grupos.update/${grupo.id_grupo}`, payload)
          }

          this.validarSuccess(
            objetivo === 1
              ? `Se activaron ${seleccion.length} grupo(s).`
              : `Se desactivaron ${seleccion.length} grupo(s).`
          )
          await this.initialize()
          this.selectedGruposAccion = []
        } catch (error) {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
        } finally {
          this.cargar = false
          this.cargarAccionMasiva = ''
        }
      },

      grupoConCalavera (item) {
        if (!item) return false
        const flag = item.reubicacion != null ? item.reubicacion : item.cerrado
        return Number(flag) === 1 || flag === true || flag === '1'
      },

      initialize () {
        if (!this.ciclo) {
          return Promise.resolve()
        }
      	this.cargar = true
        this.selectedGruposAccion = []
        this.grupos = []
        // escuela para fusionar días LMS (0 INBI / 1 FAST); sin esto el filtro de salones pierde empalme por día
        let escuela = 0
        if (this.plantel) {
          const p = (this.planteles || []).find(el => el.id_plantel == this.plantel)
          if (p && String(p.plantel || '').toUpperCase().includes('FAST')) {
            escuela = 1
          }
        }
        let payload = {
        	id_ciclo: this.ciclo,
          escuela
        }
        return this.$http.post('grupos.list', payload).then(response=>{
        	const rows = response.data || []
        	this.grupos = rows.map(el => ({
        		...el,
        		reubicacion: this.grupoConCalavera(el) ? 1 : 0
        	}))
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getCiclosDisponibles () {
      	this.cargar = true
        this.ciclosSiguientes = []
        this.$http.get('ciclos.activos.erp').then(response=>{
          for(const i in response.data){
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclosSiguientes.push(response.data[i])
              }
            }
          }
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getNiveles () {
      	this.cargar = true
        this.niveles = []
        return this.$http.get('niveles.activos').then(response=>{
        	this.niveles = response.data.filter( el => !el.nivel.match('A') || !el.nivel.match('B') )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getHorariosCatalog () {
        return this.$http.get('horarios.activos').then(response => {
          this.horariosCatalog = response.data || []
        }).catch(error => {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
        })
      },

      editItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
        this.$http.put('grupos.eliminar/' + this.editedItem.id_grupo, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      mensajeErrorAltaGrupo (error) {
        const body = (error && error.body) || (error && error.response && error.response.data) || {}
        const status = (error && error.status) || (error && error.response && error.response.status)
        if (status === 409 || body.duplicado) {
          return 'Este grupo ya existe'
        }
        return body.message || (error && error.message) || 'Error al crear el grupo'
      },

      /** Popup bloqueante: hay que pulsar Aceptar */
      mostrarAvisoGrupo (mensaje) {
        this.cargar = false
        this.respuestaAlerta = true
        this.parametros.mensaje = mensaje || 'Este grupo ya existe'
        this.parametros.color = '#FF2C2C'
        this.parametros.dialogError = false
        this.$nextTick(() => {
          this.parametros.dialogError = true
        })
      },

      save () {
      	if(this.editedItem.horario == ''){
      		this.mostrarAvisoGrupo('Favor de llenar todos los campos')
          return
      	}
      	// Cargamos al usuario que hizo el cambio
      	this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('grupos.update/' + this.editedItem.id_grupo, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
            this.close()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('grupos.add', this.editedItem).then(response=>{
          	this.initialize()
            this.close()
	        	this.cargar = false
	        }).catch( error =>{
          	this.mostrarAvisoGrupo( this.mensajeErrorAltaGrupo(error) )
        	}).finally( () => { this.cargar = false })
        }
      },

      async getGruposSiguientes (opts = {}) {
        const skipLoader = opts.skipLoader === true
        if (!skipLoader) {
          this.cargar = true
        }
        this.gruposSiguientes = []

        try {
          const response = await this.$http.post('grupos.siguientes', this.cicloSiguiente)

          this.gruposSiguientes = (response.data || [])
            .filter((el) => el.grupo && el.activo_sn2 == 1 && this.incluirGrupoSiguienteEnLista(el))

          this.selectedGruposSiguientes = []
        } catch (error) {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
        } finally {
          if (!skipLoader) {
            this.cargar = false
          }
        }
      },

      buildPayloadAperturaGrupo (item) {
        const payload = Object.assign({}, item)
        payload.id_usuario = this.getdatosUsuarioERPERP.iderp
        payload.id_grupo_original = item.id_grupo
        return payload
      },

      /** Candado: no abrir siguiente desde inactivo ni si ya tiene consecutivo. */
      validarOrigenApertura (item) {
        if (!item || !item.id_grupo) {
          this.validarErrorDirecto('Grupo origen inválido.')
          return false
        }
        if (Number(item.activo_sn2) !== 1 && Number(item.activo_sn) !== 1) {
          this.validarErrorDirecto(
            'No se puede abrir el grupo siguiente desde un grupo inactivo. Usa el grupo activo.'
          )
          return false
        }
        if (Number(item.estatus) === 1 || Number(item.id_grupo_consecutivo) > 0) {
          this.validarErrorDirecto('Este grupo ya tiene grupo siguiente asignado.')
          return false
        }
        return true
      },

      procesarUnGrupo (value) {
        if (this.cargar) {
          return
        }
        if (!this.validarOrigenApertura(value)) {
          return
        }
        const payload = this.buildPayloadAperturaGrupo(value)
        this.cargar = true
        return this.$http.post('grupos.add', payload).then(response => {
          this.editar = true
          this.validarSuccess(response.data.message)
          return this.getGruposSiguientes({ skipLoader: true })
        }).catch(error => {
          this.mostrarAvisoGrupo(this.mensajeErrorAltaGrupo(error))
        }).finally(() => {
          this.cargar = false
        })
      },

      async procesarGruposSeleccionados () {
        if (this.cargar) {
          return
        }
        const items = (this.selectedGruposSiguientes || []).slice()
        if (!items.length) {
          this.mostrarAvisoGrupo('Selecciona al menos un grupo para procesar.')
          return
        }
        const validos = items.filter((row) => {
          if (Number(row.activo_sn2) !== 1 && Number(row.activo_sn) !== 1) return false
          if (Number(row.estatus) === 1 || Number(row.id_grupo_consecutivo) > 0) return false
          return true
        })
        if (!validos.length) {
          this.validarErrorDirecto(
            'Ningún grupo seleccionado es válido para apertura (inactivos o ya con siguiente).'
          )
          return
        }
        this.cargar = true
        let ultimoMensaje = ''
        let ok = 0
        try {
          for (const row of validos) {
            const payload = this.buildPayloadAperturaGrupo(row)
            const response = await this.$http.post('grupos.add', payload)
            this.editar = true
            ok += 1
            if (response.data && response.data.message) {
              ultimoMensaje = response.data.message
            }
          }
          this.validarSuccess(
            ultimoMensaje || (ok === 1 ? 'Grupo procesado.' : `Se procesaron ${ok} grupo(s).`)
          )
          await this.getGruposSiguientes({ skipLoader: true })
        } catch (error) {
          this.mostrarAvisoGrupo(this.mensajeErrorAltaGrupo(error))
        } finally {
          this.cargar = false
        }
      },

      saveCodigoZoom( ){
      	this.cargar = true
        return this.$http.post('grupos.codigos', this.grupoZoom ).then(response=>{
        	this.dialogZoom = false
        	this.initialize()
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      }
    },
  }
</script>


<style>
  #grupos td:nth-child(1) {
    background-color: #E8E8E8 !important;
  }

  #grupos td{
    font-size: 11px !important;
    padding-left: 5px;
    padding-right: 5px;
  }

</style>